import DefaultLayout from "layouts/Default";
import LocationHeader from "components/storesPage/LocationHeader";
import Container from "components/blocks/Container";
import Wrapper from "components/blocks/Wrapper";
import Link from "next/link";
import {useSelector} from "react-redux";
import {twMerge} from "tailwind-merge";
import cn from "clsx";
import {useRouter} from "next/router";
import React, {useEffect, useState} from "react";
import {useTranslation} from "next-i18next";
import {checkMobile} from "../utils/helper";

const Tab = ({href, active, children, className, isMobile}) => (
  <Link href={href}>
    <a>
      <div
        className={isMobile ?
            cn(
                'border-t-3 border-b-3 border-transparent py-3 px-3 -m-[1px]',
                {'border-b-primary font-bold': active},
                className
            ) : cn(
                'border-t-3 border-b-3 border-transparent py-3 px-5 -m-[1px]',
                {'border-b-primary font-bold': active},
                className
            )}
      >
        {children}
      </div>
    </a>
  </Link>
)

export default function LocationLayout({children}) {
    const { t } = useTranslation()
    const location = useSelector(state => state.location.location)
  const router = useRouter()
  const slug = router.query.locationSlug
    const id = router.query.id
    const [isMobile, setIsMobile] = useState(false)

    useEffect(() => {
        console.log('location type : ', location.location_type )
        setIsMobile(checkMobile())
    }, [location])



  return (
    <div>
      <LocationHeader/>
      <Wrapper className={isMobile ? 'py-1 w-full flex flex-row justify-center' : 'py-0 border-t border-b'}>
          {
              location.location_type === 'CLINIC' ?
                  <Container className={isMobile ? 'flex justify-center w-full overflow-scroll' : 'flex w-fit'}>
                      <Tab className={isMobile ? 'flex w-full whitespace-nowrap items-center justify-center' : null} isMobile={isMobile} href={`/stores/${slug}/${id}`}
                           active={router.pathname === '/stores/[locationSlug]/[id]'}>
                          {t('home:about')}
                      </Tab>
                      <Tab className={isMobile ? 'flex w-full whitespace-nowrap items-center justify-center' : null} isMobile={isMobile} href={`/stores/${slug}/${id}/reviews`}
                           active={router.pathname === '/stores/[locationSlug]/[id]/reviews'}>
                          Reviews
                      </Tab>
                      <Tab className={isMobile ? 'flex w-full whitespace-nowrap items-center justify-center' : null} isMobile={isMobile} href={`/stores/${slug}/${id}/appointment`}
                           active={router.pathname === '/stores/[locationSlug]/[id]/appointment'}>
                          Appointment
                      </Tab>
                      <Tab className={isMobile ? 'flex w-full whitespace-nowrap items-center justify-center' : null} isMobile={isMobile} href={`/stores/${slug}/${id}/media`}
                           active={router.pathname === '/stores/[locationSlug]/[id]/media'}>
                          Media
                      </Tab>
                  </Container> :
                  <Container className={isMobile ? 'grid grid-cols-2 justify-center w-full overflow-scroll' : 'flex w-full'}>
                      <Tab className={isMobile ? 'flex w-full whitespace-nowrap items-center justify-center' : null} isMobile={isMobile} href={`/stores/${slug}/${id}`}
                           active={router.pathname === '/stores/[locationSlug]/[id]'}>
                          {t('home:store_product')}
                      </Tab>
                      <Tab className={isMobile ? 'flex w-full whitespace-nowrap items-center justify-center' : null} isMobile={isMobile} href={`/stores/${slug}/${id}/service`}
                           active={router.pathname === '/stores/[locationSlug]/[id]/service'}>
                          {t('home:store_service')}
                      </Tab>
                      <Tab className={isMobile ? 'flex w-full whitespace-nowrap items-center justify-center' : null} isMobile={isMobile} href={`/stores/${slug}/${id}/about`}
                           active={router.pathname === '/stores/[locationSlug]/[id]/about'}>
                          {t('home:store_about')}
                      </Tab>
                      <Tab className={isMobile ? 'flex w-full whitespace-nowrap items-center justify-center' : null} isMobile={isMobile} href={`/stores/${slug}/${id}/reviews`}
                           active={router.pathname === '/stores/[locationSlug]/[id]/reviews'}>
                          {t('home:store_review')}
                      </Tab>
                      {/*<Tab className={isMobile ? 'flex w-full whitespace-nowrap items-center justify-center' : null} href={`/stores/${slug}/deals`}*/}
                      {/*     active={router.pathname === '/stores/[locationSlug]/deals'}>*/}
                      {/*    Deals*/}
                      {/*</Tab>*/}
                      {/*<Tab className={isMobile ? 'flex w-full whitespace-nowrap items-center justify-center' : null} href={`/stores/${slug}/media`}*/}
                      {/*     active={router.pathname === '/stores/[locationSlug]/media'}>*/}
                      {/*    Media*/}
                      {/*</Tab>*/}
                  </Container>
          }
      </Wrapper>
      {children}
    </div>
  )
}
